
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1isd1_6966r_141",
  "marker--line": "awsui_marker--line_1isd1_6966r_184",
  "marker--rectangle": "awsui_marker--rectangle_1isd1_6966r_188",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_1isd1_6966r_195",
  "marker--dashed": "awsui_marker--dashed_1isd1_6966r_211"
};
  